import 'ember-data';

import setupContainer from 'ember-data/setup-container';

/*
  This code initializes EmberData in an Ember application.
*/
export default {
  name: 'ember-data',
  initialize: setupContainer,
};
